'use client'

import { isEstimateData, isRentData, isSaleData, isSoldData } from '@utils/house'
import { createContext, useContext } from 'react'
import { useBoolean } from 'react-use'

const SearchTypeControlContext = createContext()
export default function SearchTypeControlProvider({
  data,
  children,
}) {

  const isBuy = isSaleData(data)
  const isRent = isRentData(data)
  const isSold = isSoldData(data)
  const isEstimate = isEstimateData(data)


  // buy => buy, sold, estimate
  // rent => rent,sold, estimate
  // estimate => buy, sold, estimate
  // sold => buy, sold, estimate

  const [showSale, toggleSale] = useBoolean(isBuy || isSold || isEstimate)
  const [showRent, toggleRent] = useBoolean(isRent)
  const [showSold, toggleSold] = useBoolean(isBuy || isRent || isSold || isEstimate)
  const [showEstimate, toggleEstimate] = useBoolean(isBuy || isRent || isSold || isEstimate)
  return (
    <SearchTypeControlContext.Provider value={{
      showSale,
      showRent,
      showSold,
      showEstimate,
      toggleSale,
      toggleRent,
      toggleSold,
      toggleEstimate,
    }}>
      {children}
    </SearchTypeControlContext.Provider>
  )
}


export function useSearchTypeControlContext() {
  return useContext(SearchTypeControlContext)
}
